// extracted by mini-css-extract-plugin
export default {"wrap":"DayCounter_wrap__R7CZm","headline":"DayCounter_headline__X20Pe"};